import { FacerevealUser } from "../API";
import React, { createContext, useState, useEffect, ReactNode } from "react";
import { FacerevealResult } from "../models/Result";

export type ThemeType = "dark" | "light";

type UserInfoType = FacerevealUser & {
  picture?: string | null;
  email: string;
  refreshedAt: string;
};

interface MyContextType {
  userInfo: UserInfoType;
  setUserInfo: (value: UserInfoType) => void;
  theme: ThemeType;
  setTheme: React.Dispatch<React.SetStateAction<ThemeType>>;
  setThemeMatchBattery: React.Dispatch<React.SetStateAction<boolean>>;
  themeMatchBattery: boolean;
  selectedResult: FacerevealResult[] | null;
  setSelectedResult: React.Dispatch<
    React.SetStateAction<FacerevealResult[] | null>
  >;
  photoUri: string | null;
  setPhotoUri: React.Dispatch<React.SetStateAction<string | null>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  selectedFaceCard: FacerevealResult | null;
  setSelectedFaceCard: React.Dispatch<
    React.SetStateAction<FacerevealResult | null>
  >;
  triggerRefetch: boolean;
  setTriggerRefetch: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MyContext = createContext<MyContextType | undefined>(undefined);

interface MyProviderProps {
  children: ReactNode;
}

export const MyProvider: React.FC<MyProviderProps> = ({ children }) => {
  const [userInfo, setUserInfo] = useState<UserInfoType>({
    __typename: "FacerevealUser",
    id: "",
    tokens: 0,
    createdAt: "",
    updatedAt: "",
    email: "",
    refreshedAt: "",
  });
  const [theme, setTheme] = useState<ThemeType>(
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light",
  );
  const [themeMatchBattery, setThemeMatchBattery] = useState<boolean>(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e: MediaQueryListEvent) => {
      setTheme(e.matches ? "dark" : "light");
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  const [selectedResult, setSelectedResult] = useState<
    FacerevealResult[] | null
  >(null);
  const [photoUri, setPhotoUri] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFaceCard, setSelectedFaceCard] =
    useState<FacerevealResult | null>(null);
  const [triggerRefetch, setTriggerRefetch] = useState<boolean>(false);
  return (
    <MyContext.Provider
      value={{
        userInfo,
        setUserInfo,
        theme,
        setTheme,
        setThemeMatchBattery,
        themeMatchBattery,
        selectedResult,
        setSelectedResult,
        photoUri,
        setPhotoUri,
        loading,
        setLoading,
        selectedFaceCard,
        setSelectedFaceCard,
        triggerRefetch,
        setTriggerRefetch,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
